<template>
  <div class="Solution" v-loading="loading">
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>政采合规</li>
        <li>政策法规与合规指南</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span>首页&nbsp;></span>
          <span>政采合规</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column
            prop="title"
            label="标题"
            min-width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="clickable-cell">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="内容"
            min-width="300"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="clickable-cell">{{ getPlainText(scope.row.content) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="发布时间"
            width="180"
            align="center"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.stop="handleRowClick(scope.row)"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="page"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[6, 12, 18, 36]"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 富文本内容弹窗 -->
    <el-dialog
      title="详情"
      :visible.sync="contentDialogVisible"
      width="70%"
      :close-on-click-modal="true"
      custom-class="content-dialog"
      @close="contentDialogVisible = false"
    >
      <!-- 关键修改：添加 w-e-text 类，应用 WangEditor 样式 -->
      <div class="content-body w-e-text" v-html="currentContent"></div>
      <div style="margin-top: 20px; text-align: center;">
        <el-button
          v-if="currentFileUrl"
          type="primary"
          @click="downloadFile(currentFileUrl)"
        >
          下载附件
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Plan from '@/api/purchase.js'

export default {
  name: 'Purchase',
  data () {
    return {
      purchaseType: null,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 6,
      loading: false,
      contentDialogVisible: false,
      currentContent: '',
      currentFileUrl: ''
    }
  },
  methods: {
    decodeHtml (html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },

    getPlainText (html) {
      if (!html) return ''
      const decoded = this.decodeHtml(html)
      const text = decoded.replace(/<[^>]+>/g, '').trim()
      return text.length > 150 ? text.slice(0, 150) + '...' : text
    },

    async getList () {
      this.loading = true
      const params = {
        name: '',
        startTime: '',
        endTime: '',
        page: this.page,
        pageSize: this.pageSize,
        purchaseType: this.purchaseType || ''
      }
      try {
        const { code, msg, data, total } = await Plan.queryAcList(params)
        if (code === 200) {
          this.tableData = data || []
          this.total = total || this.tableData.length
        } else {
          this.$message.error(msg || '获取数据失败')
        }
      } catch (error) {
        console.error('API请求失败:', error)
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleRowClick (row) {
      this.currentContent = row.content || ''
      this.currentFileUrl = row.fileUrl || ''
      this.contentDialogVisible = true
    },

    downloadFile (url) {
      if (!url) {
        this.$message.warning('暂无附件可下载')
        return
      }
      window.open(url, '_blank')
    },

    handleCurrentChange (page) {
      this.page = page
      this.getList()
    },

    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.page = 1
      this.getList()
    }
  },

  mounted () {
    const type = parseInt(this.$route.query.purchaseType)
    if (type >= 1 && type <= 7) {
      this.purchaseType = type
    } else {
      this.purchaseType = null
    }
    this.getList()

    // this.$nextTick(() => {
    //   const mainContent = document.getElementById('main-content')
    //   if (mainContent) {
    //     const breadcrumb = document.querySelector('.breadcrumb')
    //     const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48
    //     const bannerHeight = 274
    //     window.scrollTo({
    //       top: bannerHeight + breadcrumbHeight - 10,
    //       behavior: 'smooth'
    //     })
    //   }
    // })
  },

  watch: {
    '$route.query.purchaseType': {
      handler (newVal) {
        const type = parseInt(newVal)
        if (type >= 1 && type <= 7) {
          this.purchaseType = type
        } else {
          this.purchaseType = null
        }
        this.page = 1
        this.getList()
      },
      immediate: false
    }
  }
}
</script>

<style scoped lang="scss">
/* 页面样式保持不变 */
.Solution {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }
        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 14px;
      img {
        width: 22px;
        height: 20px;
      }
      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }
      span {
        font-size: 16px;
        &:nth-child(1) {
          color: #666666;
        }
        &:nth-child(2) {
          color: #2b8737;
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      .page {
        display: flex;
        justify-content: center;
        margin: 20px 0 0 0;
      }
      .clickable-cell {
        cursor: pointer;
      }
    }
  }
}
.content-dialog .el-dialog__body {
  padding: 20px 30px;
  max-height: 60vh;
  overflow-y: auto;
}
.content-body {
  word-wrap: break-word;
  user-select: text;
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
<!-- 新增全局弹窗样式，无scoped直接生效 -->
<style lang="scss">
.content-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
.content-dialog .el-dialog__header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 999;
  border-bottom: 1px solid #eee;
  margin: 0;
  padding: 15px 20px;
}
.content-dialog .el-dialog__body {
  flex: 1;
  padding: 20px 30px;
  overflow-y: auto;
  max-height: calc(90vh - 70px);
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/Purchase.vue